/**
 * Age helpers for profile creation.
 *
 * Profiles belonging to a minor require the account holder to attest they hold
 * legal authority over that person, so age is computed at the point the profile
 * is created rather than read back later.
 */

/** Age in whole years on `asOf` (default: today), or null when the date is unusable. */
export const ageFromBirthDate = (value: string, asOf: Date = new Date()): number | null => {
  if (!value) return null
  const birth = new Date(value)
  if (Number.isNaN(birth.getTime())) return null

  let age = asOf.getFullYear() - birth.getFullYear()
  const monthDelta = asOf.getMonth() - birth.getMonth()
  if (monthDelta < 0 || (monthDelta === 0 && asOf.getDate() < birth.getDate())) {
    age -= 1
  }
  return age
}

/** True when the birth date places the person under 18. Future dates are not minors. */
export const isMinorBirthDate = (value: string, asOf: Date = new Date()): boolean => {
  const age = ageFromBirthDate(value, asOf)
  return age !== null && age >= 0 && age < 18
}
